import { render, staticRenderFns } from "./Suspect.vue?vue&type=template&id=6f24e136&"
import script from "./Suspect.vue?vue&type=script&lang=js&"
export * from "./Suspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports